import { Grid, Theme, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { T } from 'react-polyglot-hooks';

const image = require('./authentication.svg');

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(4)
  },
  content: {
    paddingTop: 150,
    textAlign: 'center'
  },
  image: {
    marginTop: 50,
    display: 'inline-block',
    maxWidth: '100%',
    width: 560
  }
}));

const NotAuthorised = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid container justify="center" spacing={4}>
        <Grid item lg={6} xs={12}>
          <div className={classes.content}>
            <Typography variant="h1">
              <T phrase="You are not authorised to view this content."/>
            </Typography>
            <Typography variant="subtitle2">
              <T phrase="Please use the navigation to find your way around the site."/>
            </Typography>
            <img alt="page not found" className={classes.image} src={image}/>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default NotAuthorised;
